"use strict";

var _toConsumableArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useList = function useList() {
  var initialList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _react_1$useState = react_1.useState(initialList),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      list = _react_1$useState2[0],
      set = _react_1$useState2[1];

  return [list, {
    set: set,
    updateAt: function updateAt(index, entry) {
      return set([].concat(_toConsumableArray(list.slice(0, index)), [entry], _toConsumableArray(list.slice(index + 1))));
    },
    remove: function remove(index) {
      return set([].concat(_toConsumableArray(list.slice(0, index)), _toConsumableArray(list.slice(index + 1))));
    },
    push: function push(entry) {
      return set([].concat(_toConsumableArray(list), [entry]));
    },
    filter: function filter(fn) {
      return set(list.filter(fn));
    },
    sort: function sort(fn) {
      return set(_toConsumableArray(list).sort(fn));
    }
  }];
};

exports.default = useList;